import * as SentryVue from "@sentry/vue";
import { App } from "vue";

const initSentry = (app: App<Element>) => {
    SentryVue.init({
        app,
        dsn: "https://1a4d26ac802c34f4913499e514ab3aeb@sentry.zeug.dev/18",
        integrations: [
            // SentryVue.browserTracingIntegration({
            //     routingInstrumentation: SentryVue.vueRouterInstrumentation(router),
            //     shouldCreateSpanForRequest(url: string): boolean {
            //         return !!url.match(/\/dashboard\/?$/);
            //     }
            // }),
            SentryVue.replayIntegration(),
            SentryVue.breadcrumbsIntegration(),
            SentryVue.vueIntegration({
                tracingOptions: {
                    trackComponents: ["OrderModal"],
                },
            }),
        ],
        tracePropagationTargets: ["localhost"],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.5,
        replaysOnErrorSampleRate: 1.0,
        release: process.env.VUE_APP_VERSION_NAME,
    });
};

type TrackOptions = {
    userId?: string;
    extra?: Record<string, any>;
};

type TrackParams<O = any> = TrackOptions & O;

export const sentryTrack = (params: TrackParams<{ message: string }>) => {
    const { message } = params;

    SentryVue.captureMessage(message, {
        user: {
            id: params.userId,
        },
        extra: params.extra,
        level: "debug",
    });
};

export default initSentry;
